import React from 'react';
import { AlertTriangle } from 'lucide-react';

const BanksProblem = () => {
  const pressures = [
    'Higher customer and member expectations',
    'Digital-first banking experiences',
    'Rapid product and policy changes',
    'Complex regulatory environments',
    'Multi-branch and multi-channel operations',
    'Limited time for manager coaching',
    'Rising compliance and reputation risk',
    'High frontline turnover'
  ];

  return (
    <section className="py-24 px-6">
      <div className="max-w-7xl mx-auto">
        <div className="text-center mb-16">
          <h2 className="text-4xl md:text-5xl font-bold mb-6 text-white">
            Traain for Banks & Credit Unions
          </h2>
          <h3 className="text-3xl md:text-4xl font-bold mb-8">
            <span className="text-cyan-400">Customers Expect More</span>
          </h3>
          <p className="text-xl text-gray-300 max-w-4xl mx-auto">
            But Most Banking Teams Aren't Trained for Modern Conversations.
          </p>
        </div>

        <div className="max-w-4xl mx-auto mb-12">
          <p className="text-xl font-bold text-white mb-6 text-center">Banks and credit unions are under unprecedented pressure:</p>
          <div className="grid md:grid-cols-2 gap-4">
            {pressures.map((pressure, index) => (
              <div
                key={index}
                className="flex items-start gap-4 p-6 rounded-xl bg-gradient-to-br from-red-900/20 to-orange-900/20 border border-red-500/30"
              >
                <AlertTriangle className="w-6 h-6 text-red-400 flex-shrink-0 mt-1" />
                <p className="text-lg text-gray-300">{pressure}</p>
              </div>
            ))}
          </div>
        </div>

        <div className="max-w-4xl mx-auto text-center space-y-6">
          <p className="text-lg text-gray-400 italic">
            Traditional training programs can't keep pace.
          </p>
          <p className="text-xl text-white font-semibold">
            Traain provides the enablement infrastructure financial institutions need to communicate clearly, operate consistently, and perform with confidence — at scale.
          </p>
        </div>
      </div>
    </section>
  );
};

export default BanksProblem;